import React from "react";
import { Link } from "react-router-dom";

export const LinkifiedText = ({ text }: { text: string }) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return (
    <>
      {parts.map((part, index) =>
        urlRegex.test(part) ? (
          <Link key={index} to={part} target="_blank" rel="noopener noreferrer" style={{ color: "#1a0dab" }}>
            {part}
          </Link>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </>
  );
};
